import Footer from './Footer.vue';

export default Footer;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/footer/index.ts